// extracted by mini-css-extract-plugin
export default {"login__btns":"Login_login__btns__1BP+r","login__btn":"Login_login__btn__tVKX2"};